module.exports = __webpack_public_path__ + "img/investigate.81b599ca.svg";